import * as React from "react";
import Shell from "../layout/shell";
import { isHeroSlice, isCaseStudy, isExpanders } from "../helpers/prismicHelpers";
import { Hero } from "../components/hero";
import { CaseStudy } from "../components/caseStudy";
import { Expanders } from "../components/expanders";

var WhatWeDo = function WhatWeDo(_ref) {
  var data = _ref.data;
  var content = data.prismic.allWhat_we_dos.edges[0].node;
  return /*#__PURE__*/React.createElement(Shell, null, content.body.map(function (slice) {
    if (isHeroSlice(slice)) {
      return /*#__PURE__*/React.createElement(Hero, {
        className: "hero-alt",
        data: slice
      });
    }

    if (isCaseStudy(slice)) {
      return /*#__PURE__*/React.createElement(CaseStudy, {
        data: slice
      });
    }

    if (isExpanders(slice)) {
      return /*#__PURE__*/React.createElement(Expanders, {
        data: slice
      });
    }
  }));
};

export default WhatWeDo;
export var query = "3578111976";